import { render, staticRenderFns } from "./space.vue?vue&type=template&id=81a40ace&scoped=true&"
import script from "./space.vue?vue&type=script&lang=js&"
export * from "./space.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a40ace",
  null
  
)

export default component.exports